import { Injectable ,Injector}from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiCall } from './api-call.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthTokenService {

  constructor(private injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let apicall = this.injector.get(ApiCall);
    if (localStorage.getItem('token') == null) {
      return next.handle(req);
    }
    let auth = null;
    console.log("Request URL: ", req.url);
    if (req.url.includes(environment.OUTLOOK_URL)) {
      auth = req.clone({
        setHeaders: {
          Authorization: `${apicall.getOutlookAccessToken()}`
        }
      })
    }
   else if (req.url.includes('https://graph.microsoft.com')) {
      auth = req.clone({
        setHeaders: {
          Authorization: `${apicall.getOutlookAccessToken()}`
        }
      })
    }
     else {
      auth = req.clone({
        setHeaders: {
          Authorization: `Bearer ${apicall.getToken()}`
        }
      })
    }

    return next.handle(auth);
  }
}
